import React from 'react'
import { Box, Tab, Tabs, withStyles } from '@material-ui/core'

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.primary.dark,
    // border: 'none',
    // width: '00%',
  },
}))(Tabs)

export const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: '10%',
    // fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(4),
    fontFamily: theme.typography.fontFamily,
    // border: 'none',

    '&:hover': {
      color: theme.palette.primary.dark,
      opacity: 1,
    },
    '&$selected': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      // border: 'none',
      minWidth: '10%',
    },
    '&:focus': {
      color: theme.palette.primary.dark,
      border: 'none',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />)

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props
  //console.log(index)
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  )
}
